<div class="verification-code" #codeInputsContainer>
    <input
        *ngFor="let control of codeControls; let i = index"
        [formControl]="control"
        type="text"
        maxlength="1"
        (input)="onInput($event, i)"
        (keydown)="onKeyDown($event, i)"
        autocomplete="off"
        class="code-input"
        #inputElement
    />
</div>
